<script>
import styled from "vue-styled-components";
import chroma from "chroma-js";

const CookieBannerButton = styled.a`
  padding: 1rem 2rem;
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.25s;

  &.accept {
    background-color: ${(props) => props.theme.acceptButtonColor};

    &:hover {
      background-color: ${(props) =>
        chroma(props.theme.acceptButtonColor)
          .darken()
          .hex()};
    }
  }

  &.decline {
    background-color: ${(props) => props.theme.declineButtonColor};

    &:hover {
      background-color: ${(props) =>
        chroma(props.theme.declineButtonColor)
          .darken()
          .hex()};
    }
  }

  &.advanced {
    background-color: ${(props) => props.theme.advancedAcceptButtonColor};

    &:hover {
      background-color: ${(props) =>
        chroma(props.theme.advancedAcceptButtonColor)
          .darken()
          .hex()};
    }
  }
`;

export default CookieBannerButton;
</script>
